var hiddenInput = 'bn60io2';
var hiddenInputSrOnly = 'bn60io3 _14wijgr0';
var root = 'bn60io0';
var thumb = 'bn60io1';

export { hiddenInput, hiddenInputSrOnly, root, thumb };
//# sourceMappingURL=slider-2d-primitive.css.js.map
